module.exports = __webpack_public_path__ + "static/media/29DUNON4.7f2eec60.jpg";